import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import CustomizeProjectForm from '../Pages/Customiseprojectslide';
import CustomiseprojectSlider from '../Pages/customiseprojectSlider';

const CustomizeProject = () => {

  return (
    <div className="min-h-screen bg-gray-50 font-serif antialiased">
      <Navbar />

      {/* Slide 1: Info Section */}
      <section
  className="min-h-screen bg-cover bg-center flex items-center justify-center relative text-white px-6 py-10 md:py-20"
  style={{
    backgroundImage: `url('https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Decorative/2.jpeg')`
  }}
>

        {/* Overlay for better readability */}
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>

        <motion.div
  className="relative z-10 text-center max-w-5xl mx-auto px-4 md:px-10"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 1, ease: 'easeOut' }}
>

          <h1 className="block md:hidden text-4xl font-Serif mb-6 leading-tight drop-shadow-md">

  Customise Your <span className="text-amber-300">Dream Project</span>
</h1>

          {/* For Desktop & Laptop */}
          <div className="hidden md:block text-lg md:text-xl text-gray-200 drop-shadow font-Serif space-y-5 text-center leading-relaxed">
            <p>
              At <strong>VIZAURA</strong>, we believe every space should reflect the identity behind it.
              That’s why we offer fully customized art and design solutions created in close collaboration with you.
            </p>
            <p>
              For homes, we bring together wallpapers, curated artworks, and even personalized
              collages of your family photos to craft spaces filled with warmth and meaning.
            </p>
            <p>
              For offices and commercial spaces, we design everything from decorative wallpapers to
              graphics inspired by your brand, as well as custom paintings for cabins, lounges, lobbies,
              or any corner that needs a visual voice.
            </p>
            <p>
              Whether it's a subtle touch or a bold statement, we create visuals that align with your
              brand, mood, and environment — thoughtfully designed and beautifully crafted.
            </p>
            <p>
              Browse our recent custom projects below and imagine what we can create for yours.
            </p>
          </div>

          {/* For Mobile */}
          <div className="block md:hidden text-base text-gray-200 drop-shadow font-Serif text-center px-4 mt-4">

            <p>
              At <strong>VIZAURA</strong>, we believe every space should reflect the identity behind it.
              That’s why we offer fully customized art and design solutions created in close collaboration with you.
            </p>
          </div>
        </motion.div>
      </section>

      {/* Slide 2: Form & Slider Section */}
      <section>
        <CustomiseprojectSlider />
        <CustomizeProjectForm />
      </section>

      <Footer />
    </div>
  );
};

export default CustomizeProject;
